export class Registration {
    public id: string;
    public registrationId: string;
    public startTime: Date;
    public endTime: Date;
    public startX: number;
    public startY: number;
    public endX: number;
    public endY: number;

    constructor();
    constructor(json: any);
    constructor(json?: Registration) {
        if (json) {
            this.id = json.id;
            this.registrationId = json.registrationId;
            this.startTime = json.startTime;
            this.endTime = json.endTime;
            this.startX = json.startX;
            this.startY = json.startY;
            this.endX = json.endX;
            this.endY = json.endY;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/registration.ts